<app-side-menu>
  <div class="status-content">
    <!-- Filtros -->
    <div class="filters-section">
      <div class="filters-row">
        <div class="filter-group">
          <label for="entityFilter" class="form-label">Setor</label>
          <select 
            id="entityFilter" 
            class="form-select" 
            [(ngModel)]="selectedEntityType"
            (change)="onEntityTypeChange()">
            <option value="all">Todos os Setores</option>
            <option *ngFor="let entity of entityTypes" [value]="entity.value">
              {{ entity.label }}
            </option>
          </select>
        </div>



        <div class="filter-actions">
          <button type="button" class="btn btn-outline-secondary" (click)="clearFilters()">
            <i class="fas fa-times me-2"></i>
            Limpar Filtros
          </button>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="status-card">
          <!-- Empty State -->
          <div *ngIf="!loading && (!statuses || statuses.length === 0)" class="empty-state">
            <i class="fas fa-tag"></i>
            <h3>Nenhum status encontrado</h3>
            <p>Comece cadastrando status para gerenciar os estados dos módulos do sistema.</p>
            <app-button 
              text="Cadastrar Primeiro Status"
              color="var(--primary-light)"
              (buttonClick)="createNew()"
              className="btn-primary">
              <i class="fas fa-plus me-2"></i>
            </app-button>
          </div>

          <!-- Tabela -->
          <div *ngIf="loading || (statuses && statuses.length > 0)" class="status-table">
            <div class="table-content">
              <app-table
                [title]="'Gestão de Status'"
                [data]="filteredStatuses"
                [columns]="columns"
                [loading]="loading"
                [showSearch]="true"
                [searchPlaceholder]="'Buscar por nome, código ou descrição...'"
                [clickable]="true"
                [actions]="actions"
                [disablePagination]="false"
                [totalItemsFromBackend]="totalItems"
                (rowClick)="viewStatus($event)"
                (actionClick)="onActionClick($event)"
                (pageChange)="onPageChange($event)"
                (pageSizeChange)="onPageSizeChange($event)">
                <app-button
                  table-header-action
                  text="Novo Status"
                  [color]="'var(--primary-light)'"
                  [height]="'42px'"
                  className="new-status-btn"
                  (buttonClick)="createNew()">
                </app-button>
              </app-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-side-menu>

<!-- Modal de Sucesso -->
<div *ngIf="showSuccessModal" class="modal-overlay" (click)="closeSuccessModal()">
  <div class="modal-dialog modal-success" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>
        <i class="fa-solid fa-check-circle me-2" style="color: #28a745;"></i>
        Sucesso!
      </h2>
      <button type="button" class="btn-close" (click)="closeSuccessModal()">
        <i class="fa-solid fa-times"></i>
      </button>
    </div>
    <div class="modal-body">
      <p>{{ successMessage }}</p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="closeSuccessModal()">
        OK
      </button>
    </div>
  </div>
</div>
